/* unplugin-vue-components disabled */import { render } from "./process.vue?vue&type=template&id=71a9e6b4"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=71a9e6b4&lang=less"

import exportComponent from "E:\\vuewebpage3\\ydqbyg-dz2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__